import { routes } from '@frontend/router/routes';
import type { RuteroVertical } from '@bandido/shared/types';

export interface SearchNavigationEntry {
  id: string;
  route: string;
  permission: string;
  vertical?: RuteroVertical;
}

export const SEARCH_NAVIGATION: readonly SearchNavigationEntry[] = [
  { id: 'flights', route: routes.flightsAvailability, permission: 'Flights' },
  { id: 'hotels', route: routes.hotels.home, permission: 'Hotels' },
  { id: 'transfers', route: routes.transfers, permission: 'TravelServices', vertical: 'transfers' },
  { id: 'experiences', route: routes.experiences, permission: 'TravelServices', vertical: 'tours' },
  { id: 'cars', route: routes.cars, permission: 'Cars', vertical: 'cars' },
  { id: 'rail', route: routes.rail, permission: 'TravelServices', vertical: 'rail' },
  { id: 'ferry', route: routes.ferry, permission: 'TravelServices', vertical: 'ferry' },
  { id: 'circuits', route: routes.circuits, permission: 'TravelServices', vertical: 'circuits' },
  { id: 'esims', route: routes.esims, permission: 'TravelServices', vertical: 'esims' },
  { id: 'buses', route: routes.buses, permission: 'TravelServices', vertical: 'buses' },
  { id: 'passes', route: routes.passes, permission: 'TravelServices', vertical: 'passes' },
];

export type SearchAvailability = 'loading' | 'available' | 'unavailable';

interface SearchConnector {
  vertical: string;
  configured: boolean;
  availableCapabilities?: { search?: boolean };
}

export function searchAvailability(
  vertical: string,
  settings: { data?: Record<string, string>; isLoading: boolean; isError: boolean },
  connectors: { data?: readonly SearchConnector[]; isLoading: boolean; isError: boolean; isSuccess: boolean },
): SearchAvailability {
  if (settings.isLoading) return 'loading';
  if (settings.isError || settings.data?.RUTERO_ENABLED !== 'true') return 'unavailable';
  if (connectors.isLoading) return 'loading';
  if (connectors.isError || !connectors.isSuccess) return 'unavailable';
  return connectors.data?.some(
    (connector) =>
      connector.vertical === vertical &&
      connector.configured === true &&
      connector.availableCapabilities?.search === true,
  )
    ? 'available'
    : 'unavailable';
}

export function visibleSearchEntries(
  canView: (permission: string) => boolean,
  availability: (vertical: string) => SearchAvailability,
) {
  return SEARCH_NAVIGATION.filter(
    (entry) => canView(entry.permission) && (!entry.vertical || availability(entry.vertical) === 'available'),
  );
}
